import React from 'react';
import { FilterSecondaryDropdownItem } from './FiltersSecondary.style';

interface FilterSecondaryDropdownOptionPropsType {
    isSelected?: boolean;
    onClick?: () => void;
    children: React.ReactNode;
}

export const FilterSecondaryDropdownOption = ({
    isSelected,
    onClick,
    children,
}: FilterSecondaryDropdownOptionPropsType): JSX.Element => {
    return (
        <FilterSecondaryDropdownItem
            type='button'
            isSelected={isSelected}
            onClick={onClick}
        >
            {children}
        </FilterSecondaryDropdownItem>
    );
};
